import React from 'react';

const IconButton = ({ title, onClick, children, className = '' , ariaLabel, size = 'medium' }) => {
  // size: 'small' | 'medium' | 'large'
  const sizeMap = { small: '28px', medium: '34px', large: '44px' };
  const btnSize = sizeMap[size] || sizeMap.medium;

  return (
    <button
      onClick={onClick}
      className={`icon-button ${className}`}
      title={title}
      aria-label={ariaLabel || title}
      type="button"
      style={{ '--btn-size': btnSize }}
    >
      {children}
      <style jsx>{`
        .icon-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: var(--btn-size);
          height: var(--btn-size);
          border-radius: 6px;
          border: none;
          background: transparent;
          cursor: pointer;
          padding: 4px;
        }
        .icon-button svg {
          width: calc(var(--btn-size) * 0.53);
          height: calc(var(--btn-size) * 0.53);
        }
      `}</style>
    </button>
  );
};

export default IconButton;